import React from 'react';
import YouTube from 'react-youtube';
import styled from 'styled-components';

class YoutubeVideo extends React.Component {
  render() {
    const screenWidth =
      typeof window !== 'undefined' ? window.innerWidth : 1920;

    // Calculate responsive video dimensions with rectangular/ultrawide aspect ratio
    // Using 21:9 ultrawide ratio for more rectangular shape (height = width * 9/21)
    let videoWidth = 1000;
    let videoHeight = 429; // 1000 * 9/21 = 428.57 - more rectangular

    if (screenWidth >= 2560) {
      videoWidth = 1400;
      videoHeight = 600; // 1400 * 9/21 = 600 - rectangular ultrawide
    } else if (screenWidth >= 1920) {
      videoWidth = 1200;
      videoHeight = 514; // 1200 * 9/21 = 514.29
    } else if (screenWidth <= 430) {
      // For mobile, use percentage width and calculate height
      videoWidth = screenWidth * 0.95; // 95% of screen width
      videoHeight = Math.round((videoWidth * 9) / 21); // 21:9 ratio
    } else if (screenWidth <= 768) {
      videoWidth = 700;
      videoHeight = 300; // 700 * 9/21 = 300
    }

    const opts = {
      height: String(videoHeight),
      width: String(videoWidth),
      playerVars: {
        autoplay: 0,
        start: 2,
      },
    };

    return (
      <VideoWrapper>
        <YouTube videoId="ZXNYI7NTOcE" opts={opts} onReady={this.onReady} />
      </VideoWrapper>
    );
  }

  onReady(event) {
    // Access to player in all event handlers via event.target
    // event.target.pauseVideo(); // Uncomment if you need to pause the video initially
  }
}

export default YoutubeVideo;

const VideoWrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
  padding-bottom: 42.86%; /* 21:9 ultrawide aspect ratio - more rectangular */
  height: 0;
  overflow: hidden;

  /* Alienware Aurora 16X optimization (2560x1600) - Rectangular ultrawide */
  @media (min-width: 2560px) {
    max-width: 1400px;
    padding-bottom: 42.86%; /* Maintain 21:9 rectangular */
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    max-width: 1200px;
    padding-bottom: 42.86%; /* Maintain 21:9 rectangular */
  }

  @media (max-width: 768px) {
    max-width: 700px;
    padding-bottom: 42.86%; /* Maintain 21:9 rectangular */
  }

  /* iPhone 15+ and Samsung Galaxy optimization */
  @media (max-width: 430px) {
    max-width: 92%;
    padding-bottom: 42.86%; /* Maintain 21:9 rectangular */
  }

  @media (max-width: 390px) {
    max-width: 95%;
    padding-bottom: 42.86%; /* Maintain 21:9 rectangular */
  }

  @media (max-width: 360px) {
    max-width: 98%;
    padding-bottom: 42.86%; /* Maintain 21:9 rectangular */
  }

  /* Ensure iframe fills the container and maintains aspect ratio */
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
    max-width: 100%;
    border: none;
  }

  /* Target the react-youtube wrapper */
  > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
  }
`;
